module.exports = __webpack_public_path__ + "static/media/3-PEANO.7f71dac2.mp3";